<template>
  <div class="app-body" ref="body">
    <app-header is-left @click-left="goBack">
      <div slot="title">我的订单</div>
    </app-header>
    <van-tabs v-model="activeName" class="order-tabs" @click="handleClick" @showpop="show = true" :swipe-threshold="5" sticky :offset-top="46">
      <van-tab name="all" title="全部">
      </van-tab>
      <van-tab name="0" title="待付款">
      </van-tab>
      <van-tab name="1" title="已支付">
      </van-tab>
      <van-tab name="2" title="已报名">
      </van-tab>
      <van-tab name="3" title="已完成">
      </van-tab>
      <router-view></router-view>
    </van-tabs>
    <!-- <van-popup v-model="show" :close-on-click-overlay="false" closeable class="wx_popup">
      <img :src="assetsPath + 'static/images/qrcode.jpg'" />
      <div class="text-center">长按识别二维码</div>
    </van-popup> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppHeader from '../app-header.vue';
import AppFooter from '../app-footer.vue';
import tools from '@/utils/tools';
export default {
  componentName: 'shopOrder',
  mixins: [tools],
  components: {
    AppHeader, AppFooter
  },
  data() {
    return {
      activeName: 'all',
      show: false,
    }
  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {
    if (this.show) {
      this.show = false;
      next(false);
    } else {
      next();
    }
  },
  created () {
    this.$on('type.change', (args) => {
      this.activeName = args.type || 'all';
    });
  },
  mounted () {
  },
  methods: {
    goBack(next) {
      this.$router.push({name:'shop-user'});
    },
    handleClick(name) {
      let url = '/orders';
      if (name != 'all') {
        url += '/'+ name;
      }
      if (this.$route.path !== url) {
        this.$router.push(url);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-body {margin-top:46px; background-color:#f0f0f0;}
.order-tabs {
  /deep/ .van-sticky--fixed {
    .fixedapp();
    width:100%;
  }
}
.wx_popup {
  padding:1rem;
  /deep/ .van-popup__close-icon{
    top:2px;
    right:2px;
  }
}
</style>